import { CLIENT } from './projectConstants'

interface Feature {
    title: string
    description: string
    projects: string[]
}

type FeatureId = 'ic_link' | 'ic_unlink' | 'cognito' | 'ic_enabled' | 'edit_account_details' | 'css_link' | 'css_unlink' | 'unregister_account'

type ProjectBaseFeature = {
    [K in FeatureId]: Feature;
}

export const PROJECT_BASE_FEATURE: ProjectBaseFeature = {
    ic_enabled: {
        title: 'Invoice Cloud Integration',
        description: 'Enable Invoice Cloud features in the application.',
        projects: [
            CLIENT.AR,
            CLIENT.CARMEL,
            CLIENT.DELCO,
            CLIENT.MVU,
            CLIENT.NEP
        ]
    },
    ic_link: {
        title: 'Link Invoice Cloud Account',
        description: 'Link your Invoice Cloud account from Account Manager.',
        projects: [
            CLIENT.AR,
            CLIENT.MVU,
            CLIENT.DELCO
        ]
    },
    ic_unlink: {
        title: 'Unlink Invoice Cloud Account',
        description: 'Unlink your Invoice Cloud account from Account Manager.',
        projects: [
            CLIENT.AR,
            CLIENT.MVU
        ]
    },
    cognito: {
        title: 'Cognito Integration',
        description: 'Enable Cognito authentication for user accounts.',
        projects: [
            CLIENT.MVU,
            CLIENT.NEP,
            CLIENT.CARMEL,
            CLIENT.DELCO
        ]
    },
    edit_account_details: {
        title: 'Edit Account Details',
        description: 'Allow editing of account details in Account Manager.',
        projects: [
            CLIENT.AR,
            CLIENT.DELCO,
            CLIENT.MVU,
            CLIENT.NEP,
            CLIENT.WEB
        ]
    },
    css_link: {
        title: 'Link CSS Account',
        description: 'Link your CSS account from Account Manager.',
        projects: [
            CLIENT.WEB,
            CLIENT.CARMEL,
            CLIENT.DELCO,
            CLIENT.NEP
        ]
    },
    css_unlink: {
        title: 'Unlink CSS Account',
        description: 'Unlink your CSS account from Account Manager.',
        projects: [
            CLIENT.WEB,
            CLIENT.CARMEL,
            CLIENT.DELCO,
            CLIENT.NEP
        ]
    },
    unregister_account: {
        title: 'Unregister Account',
        description: 'Unregister account from Account Manager.',
        projects: [CLIENT.WEB]
    }
}

export const isFeatureActive = (featureId: FeatureId): boolean => {
    const projectId: string | undefined = process.env.REACT_APP_CLIENT_NAME

    if (!projectId) {
        return false
    }

    const feature: Feature | undefined = PROJECT_BASE_FEATURE[featureId]

    if (!feature) {
        return false
    }

    return feature.projects.includes(projectId)
}
